import { chars, spacesReplace, whiteSpace } from './regex';

export const sanitizeSlug = (toSanitize: string | null | undefined) =>
  toSanitize
    ? toSanitize
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(chars, '')
        .replace(whiteSpace, '')
        .replace(spacesReplace, '-')
        .replace('/', '-')
        .toLowerCase()
    : '';
